export interface TestDetectable {
  isTest?: boolean;
  name?: string;
}

export function isTestUser(profile: TestDetectable): boolean {
  if (profile.isTest) {
    return true;
  }

  if (!profile.name) {
    return false;
  }

  // fallback: name starts with "Test " or "Dr. Test"
  return /^\s*(Dr\.)?\s*Test\b/i.test(profile.name);
}
